import Vue from "vue";
import Vuex from "vuex";
import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
import App from "./App.vue";
import router from "./router";
Vue.use(Vuex);
Vue.use(BootstrapVue);

import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faFacebook,
  faPinterest,
  faTwitter,
  faReddit,
  faTumblr,
} from "@fortawesome/free-brands-svg-icons";

import {
  faTrash,
  faLink,
  faListUl,
  faRandom,
  faUndo,
  faStar,
  faEdit,
  faBars,
  faTimesCircle,
  faCloudDownloadAlt,
  faShareAlt,
  faFileVideo,
  faUndoAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

library.add(
  faTrash,
  faLink,
  faListUl,
  faRandom,
  faUndo,
  faStar,
  faEnvelope,
  faEdit,
  faBars,
  faTimesCircle,
  faCloudDownloadAlt,
  faShareAlt,
  faFileVideo,
  faUndoAlt,
  faFacebook,
  faPinterest,
  faTwitter,
  faReddit,
  faTumblr
);
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
